import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import PageCardLayout from 'src/components/PageCardLayout';
import AlertCardList from './AlertCardList';
import { AlertType } from '../types';
import IncidentCardList from './IncidentCardList';

function AlertList() {
  const [type, setType] = useState(AlertType.Alerts);

  const handleChange = (event: any, newValue) => {
    setType(newValue);
  };

  return (
    <PageCardLayout title="Alerts">
      <Tabs
        value={type}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
        sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 3 }}
      >
        <Tab value={AlertType.Alerts} label="Alerts" />
        <Tab value={AlertType.Incidents} label="Incidents" />
      </Tabs>
      {type === AlertType.Alerts && <AlertCardList />}
      {type === AlertType.Incidents && <IncidentCardList />}
    </PageCardLayout>
  );
}

export default AlertList;
